import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { map, Observable } from 'rxjs';

import CONSTANTS from '../../_constants/constants';
import { environment } from '../../../environments/environment';
import { DefaultParams } from '../../_shared/interfaces/defaultParams';

import { UtilService } from '../../_shared/services/util.service';

import { Zone } from './zone.model';

interface ExtendedDefaultParams extends DefaultParams {
  by_name?: any;
  // by_status?: any;
}

@Injectable({
  providedIn: 'root',
})
export class ZoneService {
  private apiUrl = environment.apiEndpoint + 'zones';

  constructor(private http: HttpClient, private utilService: UtilService) {}

  getFilterCriteria() {
    const defaultParams: ExtendedDefaultParams = {
      // let defaultParams = {
      page: 1,
      sortDir: 'asc',
      sortedBy: 'name',
    };

    return defaultParams;
  }

  getZones(params = null): Observable<any> {
    if (!params) {
      params = this.getFilterCriteria();
    }

    const queryParams = new HttpParams({ fromObject: params });

    return this.http.get(this.apiUrl, { params: queryParams }).pipe(
      map((resp) => {
        if (resp['data']) {
          return {
            data: resp['data'],
            meta: this.utilService.getItemsMetaData(resp, this.getFilterCriteria()),
          };
        } else {
          return resp;
        }
      })
    );
  }

  getZone(id: string, params = null): Observable<Zone> {
    const queryParams = new HttpParams({ fromObject: params });

    return this.http.get<Zone>(`${this.apiUrl}/${id}`, {
      params: queryParams,
    });
  }

  // Save / Update
  saveZone(zoneId: string, zone: Zone, lang = ''): Observable<Zone> {
    const body = {
      zone: zone,
      lang: lang || CONSTANTS.DEFAULT_CONTENT_LANGUAGE,
    };

    if (!zoneId) {
      return this.http.post<Zone>(`${this.apiUrl}`, body);
    } else {
      return this.http.put<Zone>(`${this.apiUrl}/${zoneId}`, body);
    }
  }

  setZonePickUpPlaces(zones) {
    const array = [];
    zones.forEach((item) => {
      if (item.geo_lat) {
        array.push([item.name, item.geo_lat, item.geo_lng]);
      }
    });

    return array;
  }
}
